<template>
  <div class="page_top_area">
    <div class="inner-width">
      <slot />
      <div class="title_icon_area">
        <img :src="`/images/icon_${loginType}.png`">
      </div>
      <div class="title_area">
        <div class="title_name">
          {{ name }}
        </div>
        <div class="title_id">
          {{ id }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProfilesHeader',
  props: {
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    loginType: {
      type: String,
      required: true
    }
  }
}
</script>
